import { jsx as _jsx } from "react/jsx-runtime";
import { EmailAuth } from "./EmailAuth.js";
import { ExternalWalletsAuth } from "./InjectedProvidersAuth.js";
import { OAuth } from "./OAuth.js";
import { PasskeyAuth } from "./PasskeyAuth.js";
// This is not used externally
// eslint-disable-next-line jsdoc/require-jsdoc
export const AuthSection = ({ authTypes, ...props }) => {
    return (_jsx("div", { className: "akui-btn-group w-full", ...props, children: authTypes.map((authType, index) => {
            switch (authType.type) {
                case "email":
                    return _jsx(EmailAuth, { ...authType }, index);
                case "passkey":
                    return _jsx(PasskeyAuth, { ...authType }, index);
                case "social":
                    return _jsx(OAuth, { ...authType }, index);
                case "external_wallets":
                    return _jsx(ExternalWalletsAuth, {}, index);
                default:
                    throw new Error("Not implemented");
            }
        }) }));
};
//# sourceMappingURL=AuthSection.js.map